import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "url"

// Определение базового URL
// const baseUrl = 'https://test.api.navbat.tj/api/';
const baseUrl = currentUrl
// Создание API
export const clientApi = createApi({
  reducerPath: "clientApi",
  tagTypes: ["ClientHistory"],
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      const accessToken = localStorage.getItem("accessToken")
      if (accessToken) {
        const token = accessToken.startsWith("Bearer ")
          ? accessToken
          : `Bearer ${accessToken}`
        headers.set("Authorization", token)
        headers.set("Accept", "application/json")
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    updateClient: builder.mutation({
      query: (clientData) => ({
        url: `/master/clients/${clientData.id}`,
        method: "PUT",
        body: clientData,
      }),
      invalidatesTags: ["ClientHistory"],
    }),
    getClientBookingHistory: builder.query({
      query: ({ id, page = 1, perPage = 10, limit }) => ({
        url: `/master/clients/history/${id}`,
        method: "GET",
        params: { page, perPage, limit },
      }),
      providesTags: ["ClientHistory"],
    }),
    getClientHistoryRecords: builder.query({
      query: (id) => ({
        url: `/master/clients/records/${id}`,
        method: "GET",
      }),
      providesTags: ["ClientHistory"],
    }),
  }),
})


export const {
  useUpdateClientMutation,
  useGetClientBookingHistoryQuery,
  useGetClientHistoryRecordsQuery,
} = clientApi;
